/** @jsxImportSource @emotion/react */
import React, { useContext } from "react";
import { LocaleContext } from "../../context/LocaleContext";
import Button from "../Button";
import { styPadding } from "../styles";
import {
  txtCeremonyPlaceholder,
  txtCeremonyTimeInfo,
  txtDateInfo,
  txtLocationButton,
  txtLocationPlaceholder,
  txtPlaceTitle,
  txtReceptionPlaceholder,
  txtReceptionTimeInfo,
} from "./locales";
import {
  styPlace,
  styPlaceButton,
  styPlaceCard,
  styPlaceCardContent,
  styPlaceCardTitle,
  styPlaceTitle,
} from "./styles";

const Place = () => {
  const { lang } = useContext(LocaleContext);

  const onOpenLocation = () => {
    window.open("https://goo.gl/maps/V7tEuMDLaYwVttxUA", "_blank");
  };

  return (
    <section css={styPlace}>
      <div>
        <div css={styPlaceCard}>
          <h2 css={styPlaceCardTitle}>{txtPlaceTitle[lang]}</h2>
          <div css={[styPlaceCardContent, styPadding("24px 0")]}>
            <div css={styPadding("0")}>
              <p css={styPlaceTitle}>{txtCeremonyPlaceholder[lang]}</p>
              <p>{txtDateInfo[lang]}</p>
              <p>{txtCeremonyTimeInfo[lang]}</p>
            </div>
            <div css={styPadding("16px 0 0")}>
              <p css={styPlaceTitle}>{txtReceptionPlaceholder[lang]}</p>
              <p>{txtDateInfo[lang]}</p>
              <p>{txtReceptionTimeInfo[lang]}</p>
            </div>
            <div css={styPadding("16px 0 0")}>
              <p css={styPlaceTitle}>{txtLocationPlaceholder[lang]}</p>
              <p>Ndorogiri Space</p>
              <p>Bantul, DI Yogyakarta</p>
              <Button onClick={onOpenLocation} customStyles={styPlaceButton}>
                {txtLocationButton[lang]}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Place;
